import * as Eq from 'fp-ts/Eq';
export var getEq = function (k) {
    return function (cases) {
        return Eq.fromEquals(function (x, y) { return x[k] === y[k] && cases[x[k]].equals(x, y); });
    };
};
